export default __webpack_public_path__ + "static/media/ua.49c4e05b.jpg";